(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('salesBookController', salesBookController);

    salesBookController.$inject = ['$stateParams', 'datePickerService', 'taxpayers', 'linkService',
        'salesBookService', 'economicActivityService', 'dateService', 'printService', 'excelService','exportableService'];

    function salesBookController($stateParams, datePickerService, taxpayers, linkService, salesBookService,
                                 economicActivityService, dateService, printService, excelService, exportableService){
        var vm = this;
        vm.taxpayers = taxpayers;
        vm.economicActivities = [];
        vm.filterSalesBook = {
            taxpayer: null,
            economicActivity: null,
            management: null
        }
        vm.report = undefined;
        vm.fileUrl = null;
        vm.fileName = null;
        vm.isSaving = false;
        vm.isDownload = false;
        vm.isReport = false;
        vm.reportTransactionPassengerHtml = '';
        vm.filterPassages = {
            currency: null,
            region: null,
            branchOffice: null,
            user: null,
            rate: true,
            detail: true,
            fromDate: null,
            toDate: ''
        };
        vm.nameFile = '';

        vm.dateParam = $stateParams.date;
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datePickerOpenStatus = {
            dateSalesBook: false,
            datepickerOptions: {
                mode: 'month',
                minMode: 'month',
                maxMode: 'year'
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.eventChangeTaxpayer = function () {
            if (vm.filterSalesBook.taxpayer !== undefined && vm.filterSalesBook.taxpayer !== null) {
                economicActivityService.getEconomicActivitiesByTaxpayer(linkService.getLinkId(vm.filterSalesBook.taxpayer._links.self.href)).then(function (response) {
                    vm.economicActivities = response;
                });
            } else {
                vm.economicActivities = [];
                vm.filterSalesBook.economicActivity = null;
            }
        }

        vm.cancelSalesBook = function (formGenerateSalesBook) {
            vm.filterSalesBook.taxpayer = null;
            vm.filterSalesBook.economicActivity = null;
            vm.filterSalesBook.management = null;
            formGenerateSalesBook.$setPristine();
        }

        vm.generateSalesBook = function (isValid, formGenerateSalesBook) {
            if(isValid){
                var date = new Date(vm.filterSalesBook.management);
                var year = date.getFullYear();
                var month = dateService.getMonth(date.getMonth());
                var economicActivityId = linkService.getLinkId(vm.filterSalesBook.economicActivity._links.self.href);
                vm.isSaving = true;

                // txt
                /*salesBookService.getSalesBook(economicActivityId, year, month).then(function (response) {
                    var fileTxt = new Blob([response.data], { type: 'text/plain'});
                    vm.fileUrl = URL.createObjectURL(fileTxt);
                    vm.isDownload = true;
                    vm.isSaving = false;
                    vm.isReport = false;
                    vm.cancelSalesBook(formGenerateSalesBook);
                });*/

                // free marker
                /*salesBookService.getSalesBookFreeMarker(economicActivityId, year, month).then(function (response) {
                    if(response !== undefined) {
                        vm.reportTransactionPassengerHtml = response.data;
                        vm.isSaving = false;
                        vm.isReport = true;
                        vm.cancelSalesBook(formGenerateSalesBook);
                    } else {
                        vm.isReport = false;
                    }
                });*/

                // excel
                exportableService.getSalesBookXlsx(economicActivityId, year, month).then(function (response) {
                    var fileTxt = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                    vm.fileUrl = URL.createObjectURL(fileTxt);
                    vm.fileName = "reporte_ventas_" + Math.round(Date.now() / 1000) +".xlsx";
                    vm.isDownload = true;
                    vm.isSaving = false;
                    vm.isReport = false;
                    vm.cancelSalesBook(formGenerateSalesBook);
                });
            }
        }

        vm.generateTransactionsPdfHtml = function (target) {
            printService.printPdfHtml(target);
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.filterPassages.detail ? 'report_detail' : 'report_total');
        }

        vm.closeDownload = function() {
            vm.isDownload = false;
        };
    }
})();
